<template>
  <div
    class="td-news-item"
    @click="toggleNews()"
  >
    <div
      class="td-news-toggle"
    >
      <md-icon>{{ expanded ? 'remove' : 'add' }}</md-icon>
    </div>
    <div
      class="td-news-content"
    >
      <div class="td-news-text">
        {{ content }}
      </div>
      <div class="td-news-timestamp">
        {{ timestamp }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TdNewsItem",
  props: ['newsText', 'newsIndex', 'timestamp'],
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    content() {
      const trimmed = this.newsText.replace(/\*.*$/g, '');

      if (this.expanded) {
        return trimmed;
      }

      if (trimmed.length > 40) {
        return `${trimmed.substr(0, 40)}...`;
      }

      return trimmed;
    },
    isHeader() {
      return this.newsIndex === 0;
    }
  },
  methods: {
    toggleNews() {
      this.expanded = !this.expanded;
    }
  },
}
</script>

<style scoped>
.td-news-item {
  margin-bottom: 16px;
  cursor: pointer;
  display: flex;
}

.td-news-toggle {
  flex: 0 0 20px;
}

.td-news-content {
  flex: 1 0 100px;
  overflow: hidden;
  padding-left: 4px;
}

.td-news-header {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
}

.td-news-header::after {
  content: ":";
}

</style>
